import React from "react";
import PropTypes from "prop-types";
import Features from "./Features";
import "./style.css";

const WhyInvest = ({ InvestData }) => {
  return (
    InvestData && (
      <div className="w-[100%] m-auto invest_style mt-[8vw] md:mt-[1vw] mb-[5vw]">
        <Features data={InvestData} />
      </div>
    )
  );
};

WhyInvest.propTypes = {
  InvestData: PropTypes.object,
};
export default WhyInvest;
